export const forgotPassword = () => {
  return {
    title: 'OLVIDÓ SU CONTRASEÑA',
    subtitle_1: 'Ingrese el correo que fue usado para crear su cuenta.',
    subtitle_2:
      'Su email de restablecimiento de contraseña esta en camino. Asegurese de revisar su carpeta de spam o basura para recibirlo.',
    email: 'Ingrese su dirección de correo',
    send: 'Enviar',
    submit: 'Enviar',
    action_not_supported: 'Esta accion no está disponible. Contacte con su administrador para restablecer su contraseña.',
    back_to_log_in: 'Regresar a Iniciar Sesión',
    back: 'Regresar',
    email_not_found: 'Lo sentimos, este email no se encuentra en el sistema',
    email_sent: {
      title: 'Reseteo de contraseña fue enviado!',
      subtitle_1: 'Se ha enviado un correo electrónico para restablecer la contraseña. Por favor, revisa tu carpeta de spam o correo no deseado si no estás recibiendo \n correos electrónicos de MyWork Enterprise.',
      log_in: 'Iniciar sesión'
    }
  }
}
